// PANTALLA 2 — El Detonante (Documento Maestro v2.2, §2) [v2.1]
//
// ⚠️ CAMBIO DE MODELO DE NEGOCIO: la segunda pregunta ya NO es un deadline.
//    NSL dejó de prometer fechas mágicas de fluidez; ahora el usuario elige
//    cuánto peso levanta (`training_intensity`), como en un gimnasio.
//
// ⚠️ [24-09-2026] ESA SEGUNDA PREGUNTA SE MUDÓ A SU PROPIA PANTALLA.
//    Vivía aquí abajo, apareciendo al contestar la primera. Rob: «esto debería
//    ser otro paso, porque pone abajo y no me agrada; mejor un paso más». Y es
//    un problema real, no de gusto: la segunda pregunta nacía fuera de la
//    pantalla, así que el alumno contestaba, veía el botón de continuar
//    aparecer arriba y se quedaba sin saber que le faltaba algo más abajo.
//    Ahora vive en Screen2_5_Intensidad.jsx.
//
// Esta pantalla conserva la 5ª opción de texto libre (`trigger_event_custom`).
import { useState } from 'react';
import OptionCards, { MicroReaction } from './OptionCards';
import { SCREEN2_HEADLINE, TRIGGERS, CUSTOM_OPTION } from './onboardingContent';
import { etiquetaDePaso } from './pasos';

export default function Screen2_Detonante({ trigger, triggerCustom, onAnswer, onNext }) {
  const [selectedTrigger, setSelectedTrigger] = useState(trigger ?? null);
  const [custom, setCustom] = useState(triggerCustom ?? '');

  const chosenTrigger = TRIGGERS.find((t) => t.value === selectedTrigger);
  const isCustom = selectedTrigger === CUSTOM_OPTION;

  const handleTrigger = (v) => {
    setSelectedTrigger(v);
    const nextCustom = v === CUSTOM_OPTION ? custom : '';
    if (v !== CUSTOM_OPTION) setCustom('');
    onAnswer({ trigger_event: v, trigger_event_custom: nextCustom || null });
  };

  const handleCustomChange = (text) => {
    setCustom(text);
    onAnswer({ trigger_event: CUSTOM_OPTION, trigger_event_custom: text || null });
  };

  const triggerDone = Boolean(chosenTrigger) && (!isCustom || custom.trim().length > 0);

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">{etiquetaDePaso(2)}</p>
      <h1 className="ob-headline">
        <span className="ob-headline-linea">{SCREEN2_HEADLINE.linea}</span>
        <span className="ob-bloque">{SCREEN2_HEADLINE.bloque}</span>
      </h1>

      <OptionCards
        options={TRIGGERS}
        selected={selectedTrigger}
        onSelect={handleTrigger}
        customValue={custom}
        onCustomChange={handleCustomChange}
      />

      <MicroReaction text={chosenTrigger?.reaction} />

      {triggerDone && (
        <div className="ob-actions">
          <button type="button" className="ob-btn" onClick={onNext}>
            Continuar →
          </button>
        </div>
      )}
    </div>
  );
}
